// extracted by mini-css-extract-plugin
export default {"divpesquisa":"Search_divpesquisa__zdRbW","search_input":"Search_search_input__FqmMh","semBorda":"Search_semBorda__A4djy","icon":"Search_icon__t5DdJ"};